import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { newRole } from './rolesActions';

import RoleListContainer from './RoleListContainer';
import { PrimaryButton } from '../../Ui';

class RolesContainer extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="roles-container u-flex">
				<RoleListContainer />
				<PrimaryButton
					block
					fillHeight
					iconName="add-circle"
					onClick={this.props.newRole}
				>
					Ajouter un utilisateur
				</PrimaryButton>
			</div>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return {
		newRole: () => {
			dispatch(newRole());
		}
	};
}

export default withRouter(connect(null, mapDispatchToProps)(RolesContainer));



// WEBPACK FOOTER //
// ./src/js/plan/roles/RolesContainer.js